import { AfterContentInit, Directive, inject } from '@angular/core';

import { AbstractPageAnchor } from './AbstractPageAnchor';
import { ContentService } from '../services/content.service';

@Directive({
    selector: '[pfSection]',
    standalone: false,
})
export class SectionDirective
    extends AbstractPageAnchor
    implements AfterContentInit
{
    private contentService = inject(ContentService);

    ngAfterContentInit(): void {
        this.setDivider();
    }

    protected registerPageAnchor() {
        this.contentService.registerSection({
            title: this.title,
            id: this.id,
            articles: [],
        });
    }
}
